import { getDomainConfig } from '@raisin/cp-utils';
import { getBankSlug } from './bankPageUtils';

export const getBankPagePath = (locale: string) => {
  const localisedBank = getDomainConfig(locale).localisedBankPages;
  const basePath = getDomainConfig(locale).basePath;

  if (!localisedBank) {
    // eslint-disable-next-line no-console
    console.warn(`${locale} is invalid for bank pages`);
    return () => '';
  }
  return ({
    shouldUseBankSlugFallback,
    bankSlug,
    bankName,
    productId,
  }: {
    shouldUseBankSlugFallback: boolean;
    bankName: string;
    bankSlug: string;
    productId: string;
  }) => {
    const bankSlugValue = getBankSlug(shouldUseBankSlugFallback, bankSlug, bankName);
    return `${basePath}/${localisedBank}/${bankSlugValue}/${productId}`;
  };
};
